import { Injectable } from '@angular/core';
import { ModifierSetOptionBase } from './ecom-modifieroptionbase';

@Injectable()
export class ModifierSetBase {

    modifierCaption: any;
    modifiermappingGuid = '';
    modifierGuid = '';
    modifierName = '';
    modifierSetMin = 0;
    modifierSetMax = 0;
    modifierOptions: ModifierSetOptionBase[] = [];
    collapsed = false;
    quantity = 0;
    errorMessage = '';
    modifierSetSelected = false;

    constructor(data?: Partial<ModifierSetBase>) {
        Object.assign(this, data);
    }
}
